import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { featherBox, featherCheck, featherX } from '@ng-icons/feather-icons';
import { finalize } from 'rxjs';
import { CompaniaPaqueteService } from 'src/app/api/services/company-package.service';
import { APP_CONSTANTS } from 'src/app/core/constant/constants';
import { MESSAGES } from 'src/app/core/constant/messages';
import { LoadingButtonComponent } from 'src/app/shared/component/loading-button/loading-button.component';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { NavButtonComponent } from 'src/app/shared/component/nav-button/nav-button.component';
import { CompaniaPaquete, Paquete } from 'src/app/shared/model/package';
import { SolesCurrencyPipe } from 'src/app/shared/pipe/soles-currency.pipe';
import { ToastService } from 'src/app/shared/service/toast.service';
import { handleApiError } from 'src/app/shared/util/handle-api-error';

@Component({
  selector: 'app-packages',
  imports: [
    CommonModule,
    NgIcon,
    SolesCurrencyPipe,
    LoadingComponent,
    NavButtonComponent,
    LoadingButtonComponent,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './packages.component.html',
  viewProviders: [provideIcons({ featherCheck, featherBox, featherX })],
})
export class PackagesComponent {
  idCompany!: string;
  selectedPackage!: Paquete;
  packages: Paquete[] = [];
  isLoading: boolean = false;
  showModal: boolean = false;
  isLoadingPackage: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cpService: CompaniaPaqueteService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.route.parent?.params.subscribe((params) => {
      this.idCompany = params['id'];
      if (this.idCompany) {
        this.loadAllPackages();
      }
    });
  }

  loadAllPackages() {
    this.isLoading = true;
    this.cpService.getAllActive().subscribe((res) => {
      this.packages = res.dto.packages.map((pkg: Paquete) => ({
        ...pkg,
        igv: pkg.idPackage === APP_CONSTANTS.PACKAGE_ID_FREE ? '0' : '1',
      }));
      this.isLoading = false;
      this.packages = this.packages.slice(1);
    });
  }

  openModal(pkg: Paquete) {
    this.selectedPackage = pkg;
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  confirmAcquisition() {
    this.isLoadingPackage = true;

    const payload: CompaniaPaquete = {
      idCompany: this.idCompany,
      idPackage: this.selectedPackage.idPackage,
    };

    this.cpService
      .insertCompanyPackage(payload)
      .pipe(
        handleApiError(this.toastService, MESSAGES.GENERAL.ACTION_ERROR),
        finalize(() => (this.isLoadingPackage = false))
      )
      .subscribe(() => {
        this.showModal = false;
        this.router.navigate([`/user/company/${this.idCompany}/my-package`]);
        this.toastService.showMessages('success', [
          MESSAGES.GENERAL.ACTION_SUCCESS,
        ]);
      });
  }

  get routeBack(): string {
    return `/user/company/${this.idCompany}/my-package`;
  }
}
